import {
  API_CLIENT_GET_AXIOS,
  API_CLIENT_POST_AXIOS
} from "../api_call/service_instances.js";

import { GET_SETTINGS, POST_SETTINGS } from "../url/urls_in_app.js";

/*
 * --------------------------------------------------------
 *  Contain all url and fuctions needed to make call to the application
 *  only for settings part
 * --------------------------------------------------------
 */

export default {
  getSettings(user_id, lang_used) {
    return API_CLIENT_GET_AXIOS(GET_SETTINGS + user_id + "&lng=" + lang_used);
  },

  postSettings(form_data) {
    return API_CLIENT_POST_AXIOS(POST_SETTINGS, form_data);
  }
};
